import { z } from 'zod';

/**
 * Branded UUID identifier for a card. Kept in its own module so
 * sibling schemas (e.g. `TaskSchema`) can depend on it without
 * pulling the full {@link CardSchema} cycle.
 */
export const CardIdSchema = z.guid().brand<'CardId'>();

export type CardId = z.infer<typeof CardIdSchema>;
